import React, { FC, memo } from "react";
import { View } from "react-native";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { BasketIcon } from "../../../basketIcon/BasketIcon";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";
import { style } from "./ProductDetailHeader.style";

interface ProductDetailHeaderProps {
  readonly hasNotification: boolean;
  readonly onBack: () => void;
  readonly onPressBasket: () => void;
  readonly onPressWishlist: () => void;
}

const ProductDetailHeader: FC<ProductDetailHeaderProps> = ({
  hasNotification,
  onBack,
  onPressBasket,
  onPressWishlist,
}) => (
  <Header testID="product-detail-header">
    <ButtonIcon name="arrow_left" testID="arrow-left-button-icon" onPress={onBack} />
    <ButtonIconPlaceholder />
    <View style={style.buttons}>
      <ButtonIcon name="heart" testID="header-button-wishlist" onPress={onPressWishlist} />
      <BasketIcon notification={hasNotification} onPress={onPressBasket} />
    </View>
  </Header>
);

const MemoizedProductDetailHeader = memo(ProductDetailHeader);

export { MemoizedProductDetailHeader as ProductDetailHeader };
